import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-safari', 'BrandSafari', [["path",{"d":"M8 16l2 -6l6 -2l-2 6l-6 2"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}]]);